:host {
    --btn-height: 80px;
    --bottom-fixed: 60px;

    position: relative;
    z-index: 99;
}

.flyout {
    pointer-events: none;
    width: 390px;
    position: fixed;
    right: calc((var(--current-client-width) - 1760px) / 2 - 100px);
    bottom: 60px;
    background-color: $color-white;
    z-index: 1;
    box-shadow: var(--shadow-small);
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas: 'content';
    align-items: start;
    transform: translate3d(0, 100%, 0);
    opacity: 0;
    transition:
        transform 500ms,
        opacity 500ms,
        height 500ms;

    &.open {
        transform: translate3d(0, 0, 0);
        opacity: 1;
        pointer-events: all;
    }

    > * {
        grid-area: content;
        opacity: 0;
        z-index: 0;

        &.active {
            opacity: 1;
            z-index: 1;
            transition: opacity 2000ms;
        }
    }

    .overview {
        p {
            margin: 0;
        }

        .options {
            margin-top: 24px;
        }

        .option {
            all: unset;
            display: grid;
            column-gap: 10px;
            grid-template-columns: auto 1fr;
            width: 100%;
            align-items: center;
            padding: 16px 0;
            border-top: 1px solid $color-grey-03;
            cursor: pointer;

            .option-name {
                @include typo-ws-paragraph-bold;
            }

            .option-description {
                @include typo-ws-paragraph-s-plus;
            }

            &:hover {
                color: $color-red;
            }
        }
    }

    .contact,
    .contact-recruiting {
        .card-content {
            .headline {
                @include typo-ws-paragraph;
            }

            .text {
                @include typo-ws-copy-l-fixed;

                margin-top: 4px;
                color: inherit;
                text-decoration: none;

                @include mq-4-min {
                    font-size: 32px;
                    line-height: 44px;
                }
            }

            .help-text {
                @include typo-ws-paragraph-s;
            }
        }

        hr {
            all: unset;
            height: 1px;
            background-color: $color-grey-03;
            margin: 16px 0;
            display: block;
        }

        .search-field {
            margin-top: 32px;
            height: 56px;
        }

        sew-ws-linklist {
            margin-top: 32px;
        }
    }

    .tip {
        img {
            width: 100%;
        }

        .highlight-headline {
            @include typo-ws-paragraph-bold;

            margin: 20px 0 0;
        }

        .highlight-text {
            @include typo-ws-paragraph;

            margin: 8px 0 0;
        }

        .tip-btn {
            margin-top: 24px;
            width: 100%;
        }

        .tip-opt-out-link {
            --link-color: $color-grey-02-steel;

            margin-top: 24px;
            cursor: pointer;
        }
    }
}

.floating-buttons {
    pointer-events: none;
    position: fixed;
    bottom: 60px;
    right: calc((var(--current-client-width) - 1760px) / 2 - 100px);
    transform: translate3d(0, calc(var(--btn-height) + 12px), 0);
    transition: 0.3s transform ease-in-out;
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: flex-end;

    &.scroll-to-top-visible {
        transform: translate3d(0, 0, 0);

        .scroll-to-top-btn {
            pointer-events: all;
            opacity: 1;
            transform: translate3d(0, 0, 0);
        }
    }
}

.contact-options-btn {
    all: unset;
    background-color: red;
    min-width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 40px;
    cursor: pointer;

    .text {
        color: $color-white;
        max-width: 0;
        transition: max-width 300ms;
        overflow: hidden;

        > div {
            margin: 0 10px 0 30px;
            opacity: 0;
            white-space: nowrap;
        }
    }

    .text1 {
        @include typo-ws-paragraph-bold;
    }

    .text2 {
        @include typo-ws-paragraph-s;
    }

    img,
    .svg {
        width: 68px;
        height: 68px;
        object-fit: cover;
        border-radius: 50%;
        margin: 6px;
        color: $color-white;
    }

    .svg {
        display: flex;
        justify-content: center;
        align-items: center;

        svg {
            width: 48px;
        }
    }

    &:hover {
        .text {
            max-width: 300px;

            > div {
                opacity: 1;
            }
        }
    }
}

.chat-btn,
.link-btn,
.scroll-to-top-btn {
    all: unset;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 40px;
    z-index: 2;
    height: 80px;
    min-width: 80px;
    box-shadow: 0 2px 15px -5px #000;
}

sew-ws-tip-button,
.chat-btn,
.link-btn,
.contact-options-btn {
    pointer-events: all;
}

@keyframes glow {
    0% {
        box-shadow:
            0 0 0 0 rgba($color-grey-02-steel, 0.6),
            0 0 0 0 rgba($color-grey-02-steel, 0.6),
            0 0 0 0 rgba($color-grey-02-steel, 0.6),
            0 2px 15px -5px #000;
    }
    25% {
        box-shadow:
            0 0 0 13px rgba($color-grey-02-steel, 0.3),
            0 0 0 0 rgba($color-grey-02-steel, 0.6),
            0 0 0 0 rgba($color-grey-02-steel, 0.6),
            0 2px 15px -5px #000;
    }
    50% {
        box-shadow:
            0 0 0 26px rgba($color-grey-02-steel, 0),
            0 0 0 13px rgba($color-grey-02-steel, 0.3),
            0 0 0 0 rgba($color-grey-02-steel, 0.6),
            0 2px 15px -5px #000;
    }
    75% {
        box-shadow:
            0 0 0 26px rgba($color-grey-02-steel, 0),
            0 0 0 26px rgba($color-grey-02-steel, 0),
            0 0 0 13px rgba($color-grey-02-steel, 0.3),
            0 2px 15px -5px #000;
    }
    100% {
        box-shadow:
            0 0 0 26px rgba($color-grey-02-steel, 0),
            0 0 0 26px rgba($color-grey-02-steel, 0),
            0 0 0 26px rgba($color-grey-02-steel, 0),
            0 2px 15px -5px #000;
    }
}

.chat-btn,
.link-btn {
    background-color: $color-grey-02-steel;
    color: $color-white;
    animation: glow 3s linear;

    .icon {
        width: 80px;
        display: flex;
        justify-content: center;
    }

    .hover {
        max-width: 0;
        overflow: hidden;
        transition: max-width 0.6s;

        .title,
        .text {
            white-space: nowrap;
            padding-left: 32px;
        }

        .title {
            @include typo-ws-paragraph;
        }

        .text {
            @include typo-ws-paragraph-s;
        }
    }

    &:hover {
        .hover {
            max-width: 400px;
        }
    }
}

.link-btn {
    background-color: $color-white;
    color: $color-red;
    border: 1px solid $color-red;
    animation: none;

    .icon {
        width: 78px; // minus 2px because of border
    }

    .hover {
        .text {
            @include typo-ws-copy-xl-fixed;
        }
    }
}

.scroll-to-top-btn {
    pointer-events: none;
    opacity: 0;
    background-color: $color-white;
    width: 80px;
    color: $color-red;
    border: 1px solid $color-red;
    transform: translate3d(0, calc(var(--btn-height) + var(--bottom-fixed)), 0);
    transition:
        0.3s transform ease-in-out,
        opacity 900ms;

    .svg {
        transform: translateY(10%);
        transition: transform 0.2s;

        .shaft {
            opacity: 0;
            transition: opacity 0.2s;
        }
    }

    &:hover {
        .svg {
            transform: translateY(0);

            .shaft {
                opacity: 1;
            }
        }
    }

    &:active {
        background: $color-red;
        color: $color-white;
    }
}

@media (width <= 2020px) {
    .floating-buttons {
        right: 40px;
    }

    .flyout {
        right: 50px;
    }
}

@include mq-1 {
    .floating-buttons {
        right: 20px; // +10px because position changed 10px because of scaling
        bottom: 50px;
    }

    .flyout {
        top: calc(var(--header-height) + 2px);
        bottom: 0;
        right: 0;
        left: 0;
        height: calc(100vh - var(--header-height)) !important;
        width: 100%;
    }

    .contact-options-btn,
    .scroll-to-top-btn,
    .link-btn {
        scale: 0.75;
        margin: -10px 0;
        transform-origin: right;
    }
}
